import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalConstants } from 'src/app/global-constants';

@Component({
  selector: 'app-langin-page',
  templateUrl: './landing-page.page.html',
  styleUrls: ['./landing-page.page.scss']
})
export class LandingPagePage {

  constructor(private router: Router)
  {
    this.router.navigate(['sign-in'])
  }

  get pageTitle(){
    return GlobalConstants.ProjectName;
  }

}
